module.exports = __webpack_public_path__ + "static/media/points.8e446b5c.gif";